import React from 'react';
import {createRoot} from 'react-dom/client';
import {JOURNEYS} from "./constants";
import PaymentJourney from "./Journeys/PaymentJourney";
import AgentJourney from "./Journeys/AgentJourney";
import MangoJourney from "./Journeys/MangoJourney";

const Application = (props) => {
    const {
        journey,
    } = props;

    const renderJourney = () => {
        switch (journey) {
            case JOURNEYS.MANGO:
                return <MangoJourney />
            case JOURNEYS.PAYMENT:
                return <PaymentJourney />
            case JOURNEYS.AGENT:
            default:
                return <AgentJourney/>
        }
    }

    return renderJourney();
}

export default Application;

const targetNode = document.getElementById('subscription-application');
if (targetNode) {
    const root = createRoot(targetNode);
    const dataset = targetNode.dataset;

    root.render(
        <Application
            journey={!!dataset && !!dataset.journey ? dataset.journey : JOURNEYS.AGENT}
        />
    );
}
